import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import { PermissionUnauthorizedComponent } from './permission-unauthorized.component';

const routes: Routes = [
  {
    path: '',
    component: PermissionUnauthorizedComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PermissionUnauthorizedRoutingModule {
}
